import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as esAPI from '../../lib/api/esapi';
import { takeLatest } from 'redux-saga/effects';
import { remove } from 'lodash';

/**
 * 견적서 작성 화면에서 사용하는 Data 
 */

/**
 * API 서버에 Request 하는 Action Type
 */
const [
    REQ_TYPE_POST_ESAPPLY,
    REQ_TYPE_POST_ESAPPLY_SUCCESS,
    REQ_TYPE_POST_ESAPPLY_FAILURE,
] = createRequestActionTypes('esapply/REQ_TYPE_POST_ESAPPLY');

const [
    REQ_TYPE_POST_ESAPPLY_MULTI,
    REQ_TYPE_POST_ESAPPLY_MULTI_SUCCESS,
    REQ_TYPE_POST_ESAPPLY_MULTI_FAILURE,
] = createRequestActionTypes('esapply/REQ_TYPE_POST_ESAPPLY_MULTI');

// 견적 작성 상품 저장 
const ES_APPLY_PROD = 'esapply/ES_APPLY_PROD';
// 견적 작성 상품 수정 
const ES_APPLY_PROD_EDIT = 'esapply/ES_APPLY_PROD_EDIT';
// 견적 작성 상품 삭제  
const ES_APPLY_PROD_DEL = 'esapply/ES_APPLY_PROD_DEL';

// 견적 작성 상품 모두 삭제  
const ES_APPLY_PROD_DEL_ALL = 'esapply/ES_APPLY_PROD_DEL_ALL';

// 견적 정보 모두 삭제  
const ES_APPLY_DEL_ALL = 'esapply/ES_APPLY_DEL_ALL';

// 견적 요청에서 패키지 Layer 표시 
const ES_APPLY_SHOW_LAYER = 'esapply/ES_APPLY_SHOW_LAYER';

// 견적 작성 정보 저장 
const ES_APPLY_INFO = 'esapply/ES_APPLY_INFO';

/**
 * 견적서 요청 Action - Container 에서 요청 
 * 첫번째 인자 - ActionType
 * 두번째 인자 - 리듀서에서 처리 해야 할 Payload : 스토어에서 사용될 값 (생략가능)
 */
export const reqEsApplyAction = createAction(REQ_TYPE_POST_ESAPPLY, (token, info, prods) => {

    // console.log("token : " + token)
    // console.log("info : " + JSON.stringify(info))
    // console.log("prods : " + JSON.stringify(prods))
    return { token, info, prods }
});


export const reqEsApplyMultiAction = createAction(REQ_TYPE_POST_ESAPPLY_MULTI, (token, info, prods) => {

    // console.log("token : " + token)
    // console.log("info : " + JSON.stringify(info))
    // console.log("prods : " + JSON.stringify(prods))
    return { token, info, prods }
});

// 견적 작성 상품 저장 
export const setEsApplyProdAction = createAction(ES_APPLY_PROD);
// 견적 작성 상품 수정 
export const setEsApplyProdEditAction = createAction(ES_APPLY_PROD_EDIT);
// 견적 작성 상품 삭제  
export const setEsApplyProdDelAction = createAction(ES_APPLY_PROD_DEL);
// 견적 작성 상품 모두 삭제  
export const setEsApplyProdDelAllAction = createAction(ES_APPLY_PROD_DEL_ALL);
// 견적 정보 모두 삭제  
export const setEsApplyDelAllAction = createAction(ES_APPLY_DEL_ALL);
// 견적 요청에서 패키지 Layer 표시 
export const setPackLayerAction = createAction(ES_APPLY_SHOW_LAYER);
// 견적 작성 정보 저장 
export const setEsApplyInfoAction = createAction(ES_APPLY_INFO);

/**
 * SAGA API 에서 REST API 호출 
 */
const reqEsApplySaga = createRequestSaga(REQ_TYPE_POST_ESAPPLY, esAPI.postEsApplyRequest);
const reqEsApplyMultiSaga = createRequestSaga(REQ_TYPE_POST_ESAPPLY_MULTI, esAPI.postEsApplyMultiRequest);

export function* esApplyItemsSaga() {
    yield takeLatest(REQ_TYPE_POST_ESAPPLY, reqEsApplySaga);
    yield takeLatest(REQ_TYPE_POST_ESAPPLY_MULTI, reqEsApplyMultiSaga);
}


/**
 * Store에 저장될 값 
 */
const initialState = {
    esApplyResult: null,
    esApplyProdList: [],
    esApplyTotalCnt: 0,
    esApplyShowLayer: false,
    esApplyTotalPrice: 0,
    esApplyInfo: null,
    error: null,
}

export const EsApplyInfoDao = () => {
    return {
        rqst_status: null,
        pckg_nm: null, // 패키지명 
        es_prod_total_price: 0, // 전체 견적 금액 
        rqst_price: null, // 희망 견적 금액
        brnd_cd: null, // 브랜드 코드 
        estmt_type: '055101', // 견적서 타입 (일반/공간투어)
        st_id: null, // 공간투어 ID
        es_prod_cnt: 0, // 전체 상품 수 
        dsrd_date: null, // 희망 배송일 
        zipcode: null, // 우편번호
        addr1: null, // 배송 주소지
        addr2: null, // 배송 주소지 상세
        area_type: '055201', // 면적 타입 
        area_size: '5평', // 평수 
        is_install_chrg: '1', // 설치 및 조립 비용 요청 여부 (0-미요청, 1-요청)
        house_type: '055301', // 주거 형태 
        es_img_1: null,
        es_img_2: null,
        es_question: null,
        is_space:'0' //공간투어 견적요청 여부
    }
}

// ApplyProdList 에 저장될 객체 모델 
export const esApplyProdDao = () => {
    return {
        prdct_id: 0,
        prdct_nm: '',
        opt_id: 0,
        opt_nm: '',
        cate_name: '',
        prdct_price: 0, // 판매가
        sale_price: 0, // 할인가 
        opt_pirce: 0, // 옵션가 
        es_prdct_price: 0, // 견적 요청 상품 금액 ( 옵션 금액 포함, es_opt_price * qty )
        es_opt_pirce: 0, // 옵션 포함 금액 ( sale_pirce + opt_price)
        qty: 0,
        img: '',
        brnd_id: 0, // 브랜드 아이디
        brnd_nm: '', // 브랜드 이름
        brnd_logo_url: '', // 브랜드 로고 
        brnd_cd: null, // 브랜드 코드 
        sell_status:'020102', //상품 품절 체크
        opt_status: 1, //옵션 품절 체크
    }
}

// 옵션 선택 리스트에 들어가는 객체 모델 
export const esApplyOptionDao = () => {
    return {
        opt1: '', opttitle1: '',
        opt2: '', opttitle2: '',
        opt3: '', opttitle3: '',
        opt_nm: '',
        qty: 1, // 개수 
        prdct_id: 0,
        es_prdct_price: 0, // 견적 요청 상품 금액 ( 옵션 금액 포함, es_opt_price * qty )
        es_opt_pirce: 0, // 옵션 포함 금액 ( sale_pirce + opt_price)
        opt_id: 0, // 옵션 아이디 
        opt_price: 0 // 단일 옵션 금액 
    };
}

const esApplyReducer = handleActions(
    {
        [ES_APPLY_PROD]: (state, { payload: addItem }) => {
            let esApplyProdList = state.esApplyProdList;

            addItem.map((curitem) => {
                // 추가할 아이템이 이미 추가 되어 있는지 확인
                let objIdx = esApplyProdList.findIndex(obj => {
                    return (obj.prdct_id === curitem.prdct_id && obj.opt_id === curitem.opt_id);
                });

                // console.log(objIdx + " : " + JSON.stringify(addItem));

                // 신규 추가 의 경우 
                if (objIdx === -1) {
                    state.esApplyProdList.push(curitem);
                } else {
                    // 갯수 증가 시키고 전체 금액 계산 
                    let qty = ++state.esApplyProdList[objIdx].qty;
                    let price = state.esApplyProdList[objIdx].es_opt_pirce;
                    state.esApplyProdList[objIdx].es_prdct_price = (price * qty);
                }

                return null;
            })

            // 전체 갯수 구하기 
            state.esApplyTotalCnt = esApplyProdList.reduce((resobj, curobj, idx) => {
                resobj = (resobj * 1) + (curobj.qty * 1);
                // console.log("resobj : " + resobj);
                return resobj;
            }, []);

            // 전체 금액 구하기 
            state.esApplyTotalPrice = esApplyProdList.reduce((resobj, curobj, idx) => {
                resobj = (resobj * 1) + (curobj.es_prdct_price * 1);
                // console.log("resobj : " + resobj);
                return resobj;
            }, []);


            return ({ ...state });
        },
        [ES_APPLY_PROD_EDIT]: (state, { payload: prodinfo }) => {

            let esApplyProdList = state.esApplyProdList;

            // 수정할 아이템이 이미 추가 되어 있는지 확인
            let objIdx = esApplyProdList.findIndex(obj => {
                return (obj.prdct_id === prodinfo.prdct_id && obj.opt_id === prodinfo.opt_id);
            });

            if (objIdx >= 0) {
                // 갯수 증가 시키고 전체 금액 계산 
                state.esApplyProdList[objIdx].qty = prodinfo.qty;
                state.esApplyProdList[objIdx].es_prdct_price = (prodinfo.es_opt_pirce * prodinfo.qty);

                // 전체 갯수 구하기 
                state.esApplyTotalCnt = esApplyProdList.reduce((resobj, curobj, idx) => {
                    resobj = (resobj * 1) + (curobj.qty * 1);
                    // console.log("resobj : " + resobj);
                    return resobj;
                }, []);

                // 전체 금액 구하기 
                state.esApplyTotalPrice = esApplyProdList.reduce((resobj, curobj, idx) => {
                    resobj = (resobj * 1) + (curobj.es_prdct_price * 1);
                    // console.log("resobj : " + resobj);
                    return resobj;
                }, []);

            }
            return ({ ...state });
        },
        [ES_APPLY_PROD_DEL]: (state, { payload: prodinfo }) => {

            // 삭제 
            remove(state.esApplyProdList, (curitem) => {
                return (curitem.prdct_id === prodinfo.prdct_id && curitem.opt_id === prodinfo.opt_id);
            })

            // 전체 갯수 구하기 
            state.esApplyTotalCnt = state.esApplyProdList.reduce((resobj, curobj, idx) => {
                resobj = (resobj * 1) + (curobj.qty * 1);
                // console.log("resobj : " + resobj);
                return resobj;
            }, []);

            // 전체 금액 구하기 
            state.esApplyTotalPrice = state.esApplyProdList.reduce((resobj, curobj, idx) => {
                resobj = (resobj * 1) + (curobj.es_prdct_price * 1);
                // console.log("resobj : " + resobj);
                return resobj;
            }, []);


            return ({ ...state });
        },
        [ES_APPLY_PROD_DEL_ALL]: (state) => ({
            ...state,
            esApplyProdList: [],
            esApplyTotalCnt: 0,
            esApplyTotalPrice: 0
        }),
        [ES_APPLY_DEL_ALL]: (state) => ({
            ...state,
            esApplyProdList: [],
            esApplyTotalCnt: 0,
            esApplyTotalPrice: 0,
            esApplyInfo: null,
            esApplyShowLayer: false,
            esApplyResult: null
        }),
        [REQ_TYPE_POST_ESAPPLY_SUCCESS]: (state, { payload }) => {

            return ({
                ...state,
                error: null,
                esApplyInfo: null,
                esApplyProdList: [],
                esApplyTotalCnt: 0,
                esApplyTotalPrice: 0,
                esApplyShowLayer: false,
                esApplyResult: payload
            })
        }
        ,
        [REQ_TYPE_POST_ESAPPLY_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
            esApplyInfo: null,
            esApplyProdList: [],
            esApplyTotalCnt: 0,
            esApplyTotalPrice: 0,
            esApplyShowLayer: false,
            esApplyResult: error
        }),
        [REQ_TYPE_POST_ESAPPLY_MULTI_SUCCESS]: (state, { payload }) => {

            return ({
                ...state,
                error: null,
                esApplyInfo: null,
                esApplyProdList: [],
                esApplyTotalCnt: 0,
                esApplyTotalPrice: 0,
                esApplyShowLayer: false,
                esApplyResult: payload
            })
        }
        ,
        [REQ_TYPE_POST_ESAPPLY_MULTI_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
            esApplyInfo: null,
            esApplyProdList: [],
            esApplyTotalCnt: 0,
            esApplyTotalPrice: 0,
            esApplyShowLayer: false,
            esApplyResult: error
        }),
        [ES_APPLY_SHOW_LAYER]: (state, { payload: esApplyShowLayer }) => ({
            ...state,
            esApplyShowLayer,
        }),
        [ES_APPLY_INFO]: (state, { payload: esApplyInfo }) => ({
            ...state,
            esApplyInfo,
        }),
    }
    , initialState);

export default esApplyReducer;
